// import MicroModal from 'micromodal';  // es6 module
import zipCodeLookUp from '../common/zipCodeLookUp.js';
document.addEventListener("DOMContentLoaded", () => {
  zipCodeLookUp();
});
